import * as Sentry from "@sentry/nextjs"
import GenericError from "page-components/error-states/GenericError"
import { useEffect } from "react"

const CustomError = () => {
    useEffect(() => {
        Sentry.captureMessage(
            "Something went wrong. Reached CustomError page.",
            "error"
        )
    })
    return <GenericError />
}

export default CustomError
